var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"element-button primaryFont--text",attrs:{"depressed":"","color":"primary","max-width":"330px","width":"100%","height":"50px"},on:{"click":function($event){return _vm.onclick()}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }